import { Camera, Clapperboard, HeartHandshake, Gem, Flower2, Radar, BookOpen, Smartphone } from "lucide-react";
import { Reveal, SectionHeading } from "./Reveal";
import { SERVICES } from "../data/siteContent";

const ICONS = {
  Camera,
  Clapperboard,
  HeartHandshake,
  Gem,
  Flower2,
  Radar,
  BookOpen,
  Smartphone,
};

export default function Services() {
  return (
    <section id="services" data-testid="services-section" className="py-20 sm:py-28 lg:py-32 bg-ink-soft/30">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <SectionHeading
          eyebrow="What We Do"
          title={
            <>
              Every ritual, every beat, <span className="italic text-gold">beautifully kept</span>
            </>
          }
          sub="From the first haldi stain to the last dance — one studio, complete coverage, zero stress."
        />

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5 lg:gap-6">
          {SERVICES.map((s, i) => {
            const Icon = ICONS[s.icon];
            return (
              <Reveal key={s.title} delay={(i % 4) * 0.08} className="h-full">
                <div
                  data-testid={`service-card-${i + 1}`}
                  className="group relative h-full border border-white/[0.07] bg-ink-soft/60 p-6 lg:p-7 hover:border-gold/40 hover:bg-ink-elev transition-all duration-500 hover:-translate-y-1"
                >
                  <span className="absolute top-5 right-5 font-display italic text-sm text-ivory-mute/60 group-hover:text-gold/70 transition-colors">
                    {String(i + 1).padStart(2, "0")}
                  </span>
                  <div className="w-12 h-12 border border-gold/30 flex items-center justify-center mb-6 group-hover:bg-gold group-hover:text-ink text-gold transition-all duration-500">
                    <Icon className="w-5 h-5" strokeWidth={1.6} />
                  </div>
                  <h3 className="font-display text-xl sm:text-2xl font-medium text-ivory mb-2.5">
                    {s.title}
                  </h3>
                  <p className="text-sm text-ivory-dim/85 leading-relaxed">{s.desc}</p>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
